var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperPlaneTiltSend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PaperPlaneTilt - Send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4289 2.80607L1.86642 6.90763C1.74246 6.94152 1.63196 7.0128 1.54997 7.11176C1.46798 7.21073 1.41849 7.33256 1.40824 7.46066C1.39799 7.58877 1.42748 7.71691 1.4927 7.82765C1.55791 7.93839 1.65567 8.02633 1.77267 8.0795L8.46017 11.2436C8.59117 11.3042 8.69638 11.4094 8.75705 11.5404L11.9211 18.2279C11.9743 18.3449 12.0622 18.4427 12.173 18.5079C12.2837 18.5731 12.4118 18.6026 12.54 18.5924C12.6681 18.5821 12.7899 18.5326 12.8888 18.4506C12.9878 18.3687 13.0591 18.2582 13.093 18.1342L17.1945 3.57169C17.2256 3.46542 17.2275 3.35275 17.2001 3.24549C17.1727 3.13822 17.1169 3.04031 17.0386 2.96202C16.9603 2.88373 16.8624 2.82794 16.7551 2.8005C16.6479 2.77306 16.5352 2.77499 16.4289 2.80607V2.80607Z",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.66406 11.3359L12.1953 7.80469",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneTiltSend);
export default __webpack_public_path__ + "static/media/PaperPlaneTilt - Send.2038f9581ffe6302e79340eec6619a1e.svg";
export { ForwardRef as ReactComponent };